import React from 'react';
import { Badge } from '../components/ui/badge';
import { cn } from '../lib/utils';

export default function ReleaseCard({ release, copyCount, copies, onClick, className, style }) {
  const placeholderImage = 'https://images.unsplash.com/photo-1642444525640-d3eb287ed389?w=300&h=300&fit=crop';
  
  // Get first copy's condition for display
  const firstCopy = copies?.[0];
  
  return (
    <div
      className={cn(
        "album-card cursor-pointer animate-fade-in opacity-0 relative",
        className
      )}
      onClick={onClick}
      style={style}
      data-testid={`release-card-${release?.discogs_release_id}`}
    >
      {/* Copy count badge */}
      {copyCount > 1 && (
        <Badge 
          className="absolute top-2 right-2 z-10 bg-primary text-primary-foreground font-bold"
          data-testid="copy-count-badge"
        >
          x{copyCount}
        </Badge>
      )}
      
      <div className="aspect-square overflow-hidden bg-secondary">
        <img
          src={release?.cover_image_url || placeholderImage}
          alt={`${release?.artist} - ${release?.title}`}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-sm truncate" title={release?.title}>
          {release?.title}
        </h3>
        <p className="text-sm text-muted-foreground truncate" title={release?.artist}>
          {release?.artist}
        </p>
        <div className="flex items-center gap-2 mt-2">
          {firstCopy && (
            <>
              <span className="condition-badge">{firstCopy.condition_vinyl}</span>
              <span className="condition-badge">{firstCopy.condition_cover}</span>
            </>
          )}
          {release?.year && (
            <span className="text-xs text-muted-foreground ml-auto">{release.year}</span>
          )}
        </div>
      </div>
    </div>
  );
}
